import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, Observable, of, Subscribable } from 'rxjs';
import { catchError, debounceTime, distinctUntilChanged, map, skipWhile, switchMap, take } from 'rxjs/operators';
import { AuthorizeService } from 'src/api-authorization/authorize.service';
import { APIResult, WebAPIResult } from './employee.service';
import { ClientInfo } from '../shared/model/clientInfo.model';
import { Client } from '../shared/model/client.model';
import { SessionContextService } from './session-context.service';

export class CreditHistoryItem {
  Id: number;
  TransactionDate: Date;
  CreditsIn: number;
  CreditsOut: number;
  CreditsBalance: number;
  CreditSystem: string;
  Description: string;

  static CreateFrom(a: CreditHistoryItem): CreditHistoryItem {
    var r: CreditHistoryItem = new CreditHistoryItem();
    r.Id = a.Id;
    r.CreditSystem = a.CreditSystem;
    r.CreditsBalance = a.CreditsBalance;
    r.CreditsIn = a.CreditsIn;
    r.CreditsOut = a.CreditsOut;
    r.Description = a.Description;
    r.TransactionDate = a.TransactionDate;
    return r;
  }
}

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(private http: HttpClient, private auth: AuthorizeService, private session: SessionContextService) {
    console.log("Starting Client  Service");
  }

  public ValidateNewUserEmail(email: string, clientId: number): Observable<APIResult> {
    var data = {
      email: email,
      clientId: clientId
    }
    return this.http.post<WebAPIResult>('/api/Clients/ValidateClientEmail', data).pipe(
      take(1),
      catchError((e) => {
        console.log('Client Update  Error');
        console.log(e);
        var result: APIResult = new APIResult();
        result.Success = 0;
        result.Msg = e; // "There was an error updating the employee profile";
        return of(result);
      }),
      map((m) => {
        var result: APIResult = new APIResult();
        result.Success = m.Success;
        result.Msg = m.Msg;
        return result;
      })
    );
  }

  public search(terms: Observable<string>) {
    return terms.pipe(
      debounceTime(500),
      // distinctUntilChanged(),
      skipWhile((s) => s.length < 3),
      switchMap(term => this.searchEntries(term))
    )
  }

  searchEntries(term) {
    return this.http
      .get('/api/Clients/FindClient?q=' + term);
  }

  GetClientInfo(ClientId: number): Observable<ClientInfo> {    
    return this.http
      .get<ClientInfo>('/api/Clients/ClientInfo?q=' + ClientId);
  }

  GetClient(ClientId: number): Observable<Client> {
    return this.http
      .get<Client>('/api/Clients/Client?q=' + ClientId);
  }

  CreateOrUpdateClient(client: Client, disableNewOnlineClientWarning: number = 0): Observable<Client> {
    const url = `/api/Clients/CreateOrUpdateClient?disableNewOnlineClientWarning=${disableNewOnlineClientWarning}`;

    return this.http.post<Client>(url, client).pipe(
      take(1),
      catchError((e) => {
        console.log('Client Update Error');
        console.log(e);
        return EMPTY;
      }),
      map((m) => {
        if (!disableNewOnlineClientWarning) return Client.CreateFromClient(m);
      })
    );
  }

  UploadPhoto(clientId: number, photoBase64: string) {
    var data = {
      clientId: clientId,
      ImageDataBase64: photoBase64,
    };
    return this.http.post('/api/Clients/UploadClientWebCam', data).pipe(
      take(1),
      catchError((e) => {
        console.log('Client Update Error');
        console.log(e);
        return EMPTY;
      })
    );
  }

  GetClientPhotos(clientId:number):Observable<string[]>
  {
    return this.http.get<string[]>('/api/Clients/ClientPhotoUrls?C='+clientId);
  }
}